// eslint-disable-next-line import/no-extraneous-dependencies
import Qs from 'qs'
import { catchError } from '../../utils/CatchError/CatchError'
import { apiService } from '../_config_/apiservice'

export const getHistoricoBaixa = async (
  cancel: any,
  clienteId: number[],
  vendedorId: number[],
  produtoId: number[],
  empresaId: number[],
  classificacao: string[],
  dataFim: string,
  dataInicio: string,
  page: number,
  usuarioEmail: string[]
): Promise<GetHistoricoBaixaType | { message: string }> => {
  try {
    const result = await apiService.get('app/historicobaixa', {
      cancelToken: cancel.token,
      params: {
        clienteId,
        vendedorId,
        produtoId,
        empresaId,
        classificacao,
        usuarioEmail,
        dataFim,
        dataInicio,
        page: page - 1,
        size: 12,
      },
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

// Detalhe das baixas de um cliente. `produtoId`, `dataInicio` e `dataFim` sao opcionais e,
// ausentes, trazem o historico inteiro (a API nao aplica janela padrao nesta rota). As baixas vem
// da mais recente para a mais antiga, ordenadas pelo back.
export const getHistoricoBaixaDetails = async (
  clienteId: string,
  page: number,
  produtoId: number[] = [],
  dataInicio = '',
  dataFim = '',
  cancel?: any
): Promise<GetHistoryBaixaDetailType | { message: string }> => {
  try {
    const result = await apiService.get(`app/historicobaixa/${clienteId}`, {
      cancelToken: cancel?.token,
      params: {
        produtoId,
        // Data vazia sai da query em vez de virar `dataInicio=`: filtro limpo tem de dizer "sem
        // filtro" na propria URL, e nao depender de o conversor do Spring traduzir branco em null.
        ...(dataInicio ? { dataInicio } : {}),
        ...(dataFim ? { dataFim } : {}),
        page: page - 1,
        size: 7,
      },
      // Multivalorado no formato que o `@RequestParam Long[]` entende (`?produtoId=1&produtoId=2`).
      // Sem isto o axios escreve `produtoId[]=1` e o Spring ignora: o filtro sumiria em silencio.
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
    })
    if (result.status === 200) {
      return result.data
    }
  } catch (error) {
    return catchError(error)
  }
  return {
    message: 'Algo de errado aconteceu!',
  }
}

export const cancelarBaixa = async (
  id: string | undefined,
  predicaoBaixaRequestDTO: {}
): Promise<{ info: string } | { message: string }> => {
  try {
    const result = await apiService.post(
      `app/predicao/${id}/baixa/cancelar`,
      predicaoBaixaRequestDTO
    )
    if (result.status === 200) {
      return { info: 'Baixa cancelada com sucesso!' }
    }
    if (result.status === 201) {
      return { info: 'Produto criado com sucesso!' }
    }
  } catch (error) {
    return catchError(error)
  }

  return {
    message: 'Algo de errado aconteceu!',
  }
}
